import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { User } from 'types';

const verifyTotp = async ({
  userId,
  code,
}: {
  userId: string;
  code: string;
}): Promise<User> => {
  const { data } = await customAxios.post<User>(
    `/users/${userId}/mfa/totp/verify`,
    { code }
  );
  return data;
};

export const useVerifyTotp = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: verifyTotp,
    onSuccess: (data) => {
      queryClient.setQueryData(['auth-user'], data);
    },
  });
};
